export default "__VITE_ASSET__bea50456__"